import script from "./EmitsParentComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmitsParentComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EmitsParentComponent.vue?vue&type=style&index=0&id=67ae2f56&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ae2f56"]])

export default __exports__